module.exports = __webpack_public_path__ + "img/people_elements_40.976bbb6b.svg";